import React from 'react';

import useDeviceType from '../providers/DeviceType/hooks';
import ComponentType from '../types/Component';

type DesktopLayoutType = {};

const DesktopLayout: ComponentType<DesktopLayoutType> = ({ children }) => {
	const { isDesktop } = useDeviceType();

	if (!isDesktop) return null;

	return <>{children}</>;
};

export default DesktopLayout;
